import { StorageService, axios } from 'libs';

const resource = '/usuarios';

export const getUserData = () => {
  return axios.get(`${resource}/me`);
};

export const getUserPermissions = () => {
  const entidadeKey = StorageService.getItem('entidade');
  if (entidadeKey) {
    return axios.get(`${resource}/permissoes`).catch(e => {
      //Ao cancelar uma requisição ele o erro volta com a message Network Error e response undefined
      //Quando isso ocorria ele limpava a entidade indevidamente
      if (e.message === 'Network Error' && !e.response) return;

      StorageService.removeItem('entidade');
    });
  } else {
    return Promise.resolve({ data: { clientRoles: [] } });
  }
};
